import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { m as f } from "./tss-DN0acMKN.mjs";
import { A as g } from "./index-C-vGVq3z.mjs";
import { m as h } from "./motion-B7Equlyg.mjs";
const x = f()({
  crossfader: {
    position: "relative",
    "& > div": {
      position: "absolute"
    }
  },
  alignRight: {
    "& > div": {
      right: 0
    }
  },
  alignBottom: {
    "& > div": {
      bottom: 0
    }
  }
}), C = ({
  show: o,
  components: e,
  alignHorizontal: a = "left",
  alignVertical: r = "top",
  width: n = "inherit",
  height: m = "inherit"
}) => {
  const { classes: t, cx: l } = x(), c = l(t.crossfader, {
    [t.alignRight]: a === "right",
    [t.alignBottom]: r === "bottom"
  }), d = {
    height: m,
    width: n
  };
  return /* @__PURE__ */ i.jsx("div", { className: c, "data-fabric-component": "CrossFader", role: "region", style: d, children: /* @__PURE__ */ i.jsx(g, { initial: !1, children: Object.entries(e).map(
    ([s, p]) => s === o && /* @__PURE__ */ i.jsx(h.div, { animate: { opacity: 1 }, exit: { opacity: 0 }, initial: { opacity: 0 }, children: p }, s)
  ) }) });
};
export {
  C
};
//# sourceMappingURL=cross-fader-CysthR4o.mjs.map
